import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { EMAIL_VALIDATOR_KEY, ForgotUpdatePasswordRequest, REQUIRED_VALIDATOR_KEY } from '@pt/pt-models';
import { ValidatorGenerator } from '../../documents/utils/validator-generator';

@Component({
  selector: 'pt-forgot-password-update',
  templateUrl: './forgot-password-update.component.html'
})
export class ForgotPasswordUpdateComponent implements OnInit {
  // Generic
  @Input() confirmLabel!: string;
  @Input() cancelLabel!: string;
  @Input() loading: boolean;
  @Input() domain: string;
  @Input() email: string;

  // Step 1: Invio Email
  @Input() domainLabel!: string;
  @Input() emailLabel!: string;

  // Step 2: Cambio Password
  @Input() tokenLabel!: string;
  @Input() passwordLabel!: string;
  @Input() confirmPasswordLabel!: string;
  // invalid password message
  @Input() message!: string;


  @Output() onConfirm = new EventEmitter();
  @Output() onCancel = new EventEmitter();

  formGroup: FormGroup;

  ngOnInit(): void {

    const required = ValidatorGenerator.generateWidgetValidator(REQUIRED_VALIDATOR_KEY);
    const email = ValidatorGenerator.generateWidgetValidator(EMAIL_VALIDATOR_KEY);

    const domainValidators = ValidatorGenerator.generateValidator([required]);
    const emailValidators = ValidatorGenerator.generateValidator([required, email]);
    const tokenValidators = ValidatorGenerator.generateValidator([required]);

    this.formGroup = new FormGroup({
      domain: new FormControl({value: this.domain, disabled: !!this.domain}, domainValidators),
      email: new FormControl({value: this.email, disabled: !!this.email}, emailValidators),
      token: new FormControl(null, tokenValidators),
      password: new FormControl(null)
    });
  }

  confirm() {
    this.onConfirm.emit(this.formGroup.getRawValue() as ForgotUpdatePasswordRequest);
  }
}
